import React from "react"
import { Switch, Alert, Button, Space, Form } from "antd"
import { Card } from "ui/Card"
import { useTranslation } from "react-i18next"
import { InfoTooltip } from "ui/Tooltip/InfoTooltip"
import { routes } from "router"
import { useNavigate } from "react-router-dom"

export const PublishingSettings = ({ form }) => {
  const [t] = useTranslation()
  const navigate = useNavigate()

  const handleSwitchChange = (field, checked) => {
    form.setFieldsValue({
      [field]: checked
    })
  }

  return (
    <>
      <Card title={t("experiences.details.publish_settings")} className="mb-3xl">
        <div className="mb-m">
          <Space size="middle" align="center" className="flex">
            <Form.Item name="publish_on_platform" valuePropName="checked" initialValue={true} noStyle>
              <Switch onChange={(checked) => handleSwitchChange("publish_on_platform", checked)} />
            </Form.Item>
            <span>{t("experiences.details.labels.publish_marketplace")}</span>
            <InfoTooltip title={t("experiences.details.tooltips.publish_marketplace")} />
          </Space>
        </div>
        <div className="mb-m">
          <Space size="middle" align="center" className="flex">
            <Form.Item name="publish_on_guides_site" valuePropName="checked" initialValue={false} noStyle>
              <Switch onChange={(checked) => handleSwitchChange("publish_on_guides_site", checked)} />
            </Form.Item>
            <span>{t("experiences.details.labels.publish_website")}</span>
            <InfoTooltip title={t("experiences.details.tooltips.publish_website")} />
          </Space>
        </div>
        <Alert
          type="info"
          showIcon
          className="gap-3"
          icon={
          <InfoTooltip title={t("experiences.details.labels.publish_website_info")} 
          width={20} 
          height={20}
          />}
          message={
            <span>
              {t("experiences.details.labels.publish_website_info")} -{" "}
              <Button type="link" className="p-0" onClick={() => navigate(routes.proSettingsWebsiteIntegration())}>
                {t("global.website_integration")}
              </Button>
              .
            </span>
          }
        />
      </Card>
    </>
  )
}
